var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"launch"},[_c('h1',[_vm._v("This is an launch page")]),_c('div',[_vm._v("code: "+_vm._s(_vm.$route.params.code)+" ")]),_c('div',[_vm._v("engine: "+_vm._s(_vm.$route.params.engine)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }